import type { ColDef } from 'ag-grid-community';
import type { TFunction } from 'i18next';

const useColdefConditionOrdinaryDomesticAichi = (t: TFunction<'translation', undefined>) => {
  const colDefs: ColDef[] = [
    {
      headerName: '',
      colId: 'actions',
      cellRenderer: 'actionsManageCondition',
      editable: false,
      filter: false,
      pinned: 'left',
      suppressMenu: true,
      cellStyle: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
      minWidth: 90,
      maxWidth: 90,
    },
    {
      field: 'customer',
      headerName: t('condition.customer'),
      headerTooltip: t('condition.customer'),
      width: 150,
    },
    {
      field: 'customerName',
      headerName: t('condition.customerName'),
      headerTooltip: t('condition.customerName'),
    },
    {
      field: 'deliveryLocation',
      headerName: t('deliveryLocation.deliveryLocation'),
      headerTooltip: t('deliveryLocation.deliveryLocation'),
      width: 150,
    },
    {
      field: 'deliveryLocationName',
      headerName: t('deliveryLocation.deliveryLocationName'),
      headerTooltip: t('deliveryLocation.deliveryLocationName'),
    },
  ];

  return colDefs;
};

export default useColdefConditionOrdinaryDomesticAichi;
